module.exports = __webpack_public_path__ + "static/img/prod_pic07.ecd32e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic07.jpg
// module id = Wgnn
// module chunks = 5